import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import subImage from '../../../images/my-image/borna-3.jpg';
import './HomeAbout.css';

const HomeAbout = () => {
    return (
        <div className='subAbout'>
            <Container className='sub-container'>
                <Row>
                    <Col lg={7} md={7} sm={12}>
                        <div className='text-start p-5 subAbout-text'>
                            <div className='d-flex'>
                                    <h2>ABOUT ME</h2>
                                    <h5 className='sub-border'>.</h5>
                            </div>
                            <p className='mt-3'>I'm DILRUBA BORNA. 2021 in graduated from the University of Development Alternative in Dept. of CSE. As a CSE student, I'm very enthusiastic about web development and recently completed a web development course.</p>
                            <p>I wanted to start my career as a junior web developer. I am proficient in HTML5, CSS3, Bootstrap, Tailwind, JavaScript, and react JS, and have a decent experience in NodeJS, express JS, and MongoDB.</p>
                        </div>

                        <div className='d-flex'>
                                <div className='sub-ul'>
                                    <ul>
                                        <li>
                                            <b className='text-dark'>Age : </b> 
                                            <span>23</span>
                                        </li>
                                        <li>
                                            <b className='text-dark'>Nationality : </b> <span>Bangladesh</span>
                                        </li>
                                        <li>
                                            <b className='text-dark'>Status : </b> <span>Available</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className='sub-ul mx-5'>
                                    <ul>
                                        <li>
                                            <b className='text-dark'>Address : </b> 
                                            <span>Dhaka</span></li>
                                        <li>
                                            <b className='text-dark'>Langages : </b> 
                                            <span>English</span>
                                        </li>
                                        <li>
                                            <b className='text-dark'>Email : </b> 
                                            <span>borna.dilruba@gmail.com</span>
                                        </li>
                                     </ul>
                                </div>
                        </div>

                        <div className='sub-card'>
                            <div>
                                <h3>3+</h3>
                                <p><span>&#8212;</span> YEARS OF EXPERIENCE</p>
                            </div>

                            <div>
                                <h3>20+</h3>
                                <p><span>&#8212;</span> COMPLETED PROJECTS</p>
                            </div>

                            <div>
                                <h3>10+</h3>
                                <p><span>&#8212;</span> FEEDBACKS</p>
                            </div>

                            <div>
                                <h3>10K+</h3>
                                <p><span>&#8212;</span> LINE CODES</p>
                            </div>
                        </div>
                    </Col>
                    <Col lg={5} md={5} sm={12}>
                        <div className='subAbout-img p-5'>
                            <img src={subImage} alt="" />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default HomeAbout;